import { ROUTES } from "./site";
import { BA_STOPS } from "./routePages";

const toMin = (t) => { const [h, m] = t.split(":").map(Number); return h * 60 + m; };

// Salidas reales de `origin` a `dest` según los recorridos (primer embarque en origen, primera llegada a destino).
export const departuresBetween = (origin, dest) => ROUTES.flatMap((r) => {
  const i = r.stops.findIndex((s) => s[2] === origin);
  const j = r.stops.findIndex((s, k) => k > i && s[2] === dest);
  if (i < 0 || j < 0) return [];
  let mins = 0;
  for (let k = i + 1; k <= j; k += 1) mins += (toMin(r.stops[k][1]) - toMin(r.stops[k - 1][1]) + 1440) % 1440;
  return [{ id: r.id, name: r.name, days: r.days, from: r.stops[i], to: r.stops[j], minutes: mins }];
}).sort((a, b) => a.from[1].localeCompare(b.from[1]));

// Ciudades desde las que se puede viajar a `dest`.
export const originsFor = (dest) => [...new Set(ROUTES.flatMap((r) => {
  const j = r.stops.map((s) => s[2]).lastIndexOf(dest);
  return j > 0 ? r.stops.slice(0, j).map((s) => s[2]) : [];
}))].filter((c) => c !== dest);

export const defaultOrigin = (dest) => {
  const opts = originsFor(dest);
  const pref = BA_STOPS.includes(dest) ? ["Santiago del Estero", "Tucumán"] : ["Retiro", "Santiago del Estero"];
  return pref.find((c) => opts.includes(c)) || opts[0] || "";
};
